import React from 'react';
import { Loader, BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const FulfillmentOrderItemsListTemplate = ({
	fulfillmentOrderItemsListViewStore,
	fulfillmentOrderItemsListViewStore: { loading, listStore, tableData, queryUtility, noDataItem },
	actions,
	showActions,
	data,
}) => {
	if (loading) return <Loader />;
	return (
		<section className="k-grid__header--sml spc--top--sml">
			<BaasicTable
				{...{
					listStore,
					data,
					tableData,
					queryUtility,
					fulfillmentOrderItemsListViewStore,
					actions,
					showActions,
					noDataItem,
				}}
			/>
		</section>
	);
};

export default defaultTemplate(FulfillmentOrderItemsListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/FulfillmentOrderItemsListTemplate.jsx